import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { LayoutModule } from '../layout/layout.module';
import { DecodePipeModule } from '../shared/pipes/decode/decode.module';
import { SafeStringModule } from '../shared/pipes/safe-string/safe-string.module';
import { SanitizePipeModule } from '../shared/pipes/sanitize/sanitize.module';
import { SharedModule } from '../shared/shared.module';
import { NotifyTemplateFormDialogComponent } from './notify-template-form-dialog/notify-template-form-dialog.component';
import { NotifyTemplateFormComponent } from './notify-template-form/notify-template-form.component';
import {
    NotifyTemplatePreviewDialogComponent,
} from './notify-template-preview-dialog/notify-template-preview-dialog.component';
import { NotifyTemplatePreviewComponent } from './notify-template-preview/notify-template-preview.component';
import {
    NotifyTemplateThumbnailComponent,
} from './notify-template/notify-template-thumbnail/notify-template-thumbnail.component';
import { NotifyTemplateComponent } from './notify-template/notify-template.component';
import { NotifyTemplatesRoutingModule } from './notify-templates-routing.module';
import { NotifyTemplatesComponent } from './notify-templates.component';
import { NotifyTemplateService } from './services/notify-template.service';

@NgModule({
    imports: [
        NotifyTemplatesRoutingModule,
        SharedModule,
        LayoutModule,
        ReactiveFormsModule,
        SafeStringModule,
        TranslateModule,
        SanitizePipeModule,
        DecodePipeModule,
    ],
    declarations: [
        NotifyTemplatesComponent,
        NotifyTemplateComponent,
        NotifyTemplateThumbnailComponent,
        NotifyTemplatePreviewComponent,
        NotifyTemplatePreviewDialogComponent,
        NotifyTemplateFormDialogComponent,
        NotifyTemplateFormComponent,
    ],
    providers: [NotifyTemplateService],
})
export class NotifyTemplatesModule {
}
